/**
 * @generated SignedSource<<e4bd8c880301ab07b2a525db2daeff14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type UnsubscribeActualPlanTaskInput = {
  environment: ZakekeEnvironment;
  masterSalesChannelID?: string | null;
  secondarySalesChannelID?: string | null;
};
export type salesChannelGenerateUnsubscribeTaskMutation$variables = {
  input: UnsubscribeActualPlanTaskInput;
};
export type salesChannelGenerateUnsubscribeTaskMutation$data = {
  readonly generateUnsubscribeActualPlanTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelGenerateUnsubscribeTaskMutation = {
  response: salesChannelGenerateUnsubscribeTaskMutation$data;
  variables: salesChannelGenerateUnsubscribeTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "generateUnsubscribeActualPlanTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelGenerateUnsubscribeTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "salesChannelGenerateUnsubscribeTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "462b0f5a6bb6eb1a3398198107dd4b70",
    "id": null,
    "metadata": {},
    "name": "salesChannelGenerateUnsubscribeTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelGenerateUnsubscribeTaskMutation(\n  $input: UnsubscribeActualPlanTaskInput!\n) {\n  generateUnsubscribeActualPlanTask(input: $input) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e928e1faf535e7a1cde241fb063e9fb";

export default node;
